/**
 * S-curve period table.
 * Route: /reports/s-curve
 * Shows the same mapped rows as the chart. Does not fetch.
 */
import { ScrollArea, Table, Text } from '@mantine/core';
import type { SCurveChartRow } from '../logic/mapSCurveChart';
import { formatAmount, formatPercent, formatVariance } from './sCurveFormat';

export default function SCurvePointsTable({
  rows,
  showPeriodAmounts,
  unit,
}: {
  rows: SCurveChartRow[];
  showPeriodAmounts: boolean;
  unit: string;
}) {
  const amountHint = unit ? ` (${unit})` : '';
  return (
    <ScrollArea h={360} type="auto">
      <Table stickyHeader striped highlightOnHover>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Period</Table.Th>
            {showPeriodAmounts ? (
              <>
                <Table.Th>Planned this period{amountHint}</Table.Th>
                <Table.Th>Actual this period{amountHint}</Table.Th>
              </>
            ) : null}
            <Table.Th>Planned cumulative{amountHint}</Table.Th>
            <Table.Th>Actual cumulative{amountHint}</Table.Th>
            <Table.Th>Planned</Table.Th>
            <Table.Th>Actual</Table.Th>
            <Table.Th>Variance</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {rows.map((row, index) => (
            <Table.Tr key={`${row.periodLabel}-${index}`}>
              <Table.Td>{row.periodLabel}</Table.Td>
              {showPeriodAmounts ? (
                <>
                  <Table.Td>{formatAmount(row.plannedPeriod)}</Table.Td>
                  <Table.Td>{formatAmount(row.actualPeriod)}</Table.Td>
                </>
              ) : null}
              <Table.Td>{formatAmount(row.plannedCumulative)}</Table.Td>
              <Table.Td>{formatAmount(row.actualCumulative)}</Table.Td>
              <Table.Td>{formatPercent(row.planned)}</Table.Td>
              <Table.Td>{formatPercent(row.actual)}</Table.Td>
              <Table.Td>
                <Text
                  size="sm"
                  c={row.variance == null ? undefined : row.variance >= 0 ? 'teal' : 'red'}
                >
                  {formatVariance(row.variance)}
                </Text>
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </ScrollArea>
  );
}
